export const eneeComponents = {
  accordion: {
    header: {
      hoverColor: '{primary.color}',
      activeColor: '{primary.color}',
      fontWeight: '500',
      toggleIcon: {
        activeColor: '{primary.color}',
        activeHoverColor: '{primary.color}',
      },
    },
    colorScheme: {
      light: {
        header: {
          background: '{content.background}',
          hoverBackground: '{primary.50}',
          activeBackground: '{content.background}',
          activeHoverBackground: '{primary.50}',
        },
      },
      dark: {
        header: {
          background: '{content.background}',
          hoverBackground: '{surface.700}',
          activeBackground: '{content.background}',
          activeHoverBackground: '{surface.700}',
        },
      },
    },
  },
  button: {
    root: {
      label: {
        fontWeight: '500',
      },
    },
    colorScheme: {
      light: {
        outlined: {
          primary: {
            borderColor: '{primary.color}',
          },
        },
      },
    },
  },
  card: {
    root: {
      borderRadius: '{border.radius.md}',
      shadow: 'none',
    },
    body: {
      gap: '0',
    },
  },
  datatable: {
    columnTitle: {
      fontWeight: '600',
    },
    colorScheme: {
      light: {
        headerCell: {
          color: '{text.muted.color}',
        },
      },
    },
  },
  menu: {
    root: {
      borderRadius: '{border.radius.sm}',
    },
  },
  menubar: {
    baseItem: {
      borderRadius: '{border.radius.sm}',
    },
  },
}
